// extracted by mini-css-extract-plugin
module.exports = {"form__button--submit":"SendTestEmail_form__button--submit__3U94-"};